import axios from 'axios'

const deleteSubCategory = async (id) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/deleteSubCategory/${id}`,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data.data
  } catch (error) {
    throw error
  }
}

export default deleteSubCategory
